/**
 * helpers/formatCurrency.ts
 *
 * Currency formatting utilities for the renovation/energy dashboard.
 */

const euroFormatter = new Intl.NumberFormat("nl-BE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

const euroCompactFormatter = new Intl.NumberFormat("nl-BE", {
  style: "currency",
  currency: "EUR",
  notation: "compact",
  maximumFractionDigits: 1,
});

/**
 * Formats a number as a full euro string (e.g., "€ 12.450").
 * Uses nl-BE locale (period as thousands separator, comma for decimals).
 */
export function formatEuro(value: number): string {
  return euroFormatter.format(value);
}

/**
 * Formats a number as compact euro string (e.g., "€ 12,5k", "€ 1,2M").
 * Useful for hero cards and chart labels where space is limited.
 */
export function formatEuroCompact(value: number): string {
  return euroCompactFormatter.format(value);
}
